import { IPoi, IEventPoiagg } from "~/interfaces";
import { node } from "~/util/dom";
import { createPOIListImage } from "./poilistimage";

export interface IPOIListItemData {
	source: string;
	id: string | number;
	title: string;
	poiTypeName?: string;
	poiTypeId?: number;
	thumbnail: string;
	address: string;
}

interface IPOIListItemOptions {
	data: IPoi | IEventPoiagg;
	paid?: boolean;
	onClick: () => void;
}

export default class POIListItem {
	_container: HTMLDivElement;

	_data: IPoi | IEventPoiagg;

	_onClick: () => void;

	_paid: boolean;

	constructor({ data, onClick, paid = false }: IPOIListItemOptions) {
		this._container = node("div", { className: `ui-poilistitem ${onClick ? "ui-poilistitem--clickable" : ""}` });
		this._data = data;
		this._paid = paid;
		this._onClick = onClick;
		this._build();
	}

	destroy() {
		this._container.removeEventListener("click", this);
	}

	get node() {
		return this._container;
	}

	handleEvent() {
		this._onClick && this._onClick();
	}

	_build() {
		const text = node("div");

		text.appendChild(node("h3", { innerHTML: this._data.titleVars.titleSmartMain, title: this._data.titleVars.titleSmartMain }));
		if (this._data.typeName) {
			text.appendChild(node("p", { className: "ui-poilistitem__category", innerHTML: this._data.typeName, title: this._data.typeName }));
		}
		text.appendChild(node("p", { className: "ui-poilistitem__address", innerHTML: this._data.titleVars.locationMain1, title: this._data.titleVars.locationMain1 }));

		this._container.appendChild(createPOIListImage(this._data, this._paid));
		this._container.appendChild(text);
		this._container.addEventListener("click", this);
	}
}
